import { defineStore } from 'pinia'
import { ref } from 'vue'
export const useAlertStore = defineStore('alert', () => {
    const type = ref(false)
    const msg = ref('')
    return { type , msg }
})